module.exports = __webpack_public_path__ + "assets/img/first_user_s.1c3e2a47.svg";